import { render, staticRenderFns } from "./CustomerOrdersSearch.vue?vue&type=template&id=85413e1a&"
import script from "./CustomerOrdersSearch.vue?vue&type=script&lang=js&"
export * from "./CustomerOrdersSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports